<!--
 * @Author: DYM
 * @Date: 2020-08-11 10:17:57
 * @LastEditors: zxf
 * @LastEditTime: 2022-03-15 19:57:37
 * @Description: 柱状/折线图
-->
<template>
  <div
    ref="chartWrapper"
    v-resize:debounce.500="resizeChart"
    :style="{width: width ? width + 'px' : '100%',height: height ? height + 'px' : '100%'}"
  >
    <div
      ref="vueChart"
      style="width: 100%;height: 100%;"
    >
      {{ data }}
    </div>
  </div>
</template>

<script>
import resize from 'vue-resize-directive';
import chartConfig from './chart.config';

export default {
  name: 'LineLineChart',
  directives: {
    resize
  },
  props: {
    isFinished: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: () => {
        return null;
      }
    },
    height: {
      type: Number,
      default: () => {
        return null;
      }
    },
    labelLine: {
      type: Number,
      default: () => {
        return null;
      }
    },
    title: {
      type: String,
      default: ''
    },
    chartOpt: {
      required: false,
      type: Object,
      default: function () {
        return {};
      }
    },
    seriesOpt: {
      required: false,
      type: Object,
      default: function () {
        return {};
      }
    },
    data: {
      required: false,
      type: Array,
      default: function () {
        return []; // [{name:'柱状分类名称',data:[{value: 100, name: 'x轴名称'}]]
      }
    },
    lineDataName: {
      required: false,
      type: Array,
      default: function () {
        return []; // ['折线数据名称']
      }
    },
    horizontal: {
      required: false,
      type: Boolean,
      default: false
    },
    showLegend: {
      required: false,
      type: Boolean,
      default: false
    },
    barMax: {
      type: Number,
      default: () => {
        return null;
      }
    },
    barMin: {
      type: Number,
      default: () => {
        return null;
      }
    },
    lineMax: {
      type: Number,
      default: () => {
        return null;
      }
    },
    lineMin: {
      type: Number,
      default: () => {
        return null;
      }
    },
    barYAxis: {
      type: String,
      default: ''
    },
    lineYAxis: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      vueChart: {},
      observer: null
    };
  },
  computed: {
    originData () {
      return this.data;
    },
    originChartOpt () {
      const that = this;
      const defaultOpt = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          show: true,
          top: that.title ? '22' : '0',
          right: '20',
          iconStyle: {
            borderColor: '#333'
          },
          feature: {
            // saveAsImage: {}
          }
        },
        grid: {
          left: '30',
          right: '30',
          bottom: '30',
          containLabel: true
        },
        legend: {
          show: that.showLegend,
          data: [],
          bottom: 0,
          itemWidth: 12
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLine: {
            lineStyle: {
              color: '#ccc'
            }
          },
          axisTick: {
            show: true
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            color: '#000',
            formatter: (val) => {
              if (val.length > 10) {
                return val.substring(0, 10) + '...';
              } else {
                return val;
              }
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            min: that.barMin,
            max: that.barMax,
            axisLine: {
              lineStyle: {
                color: '#ccc'
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              color: '#000',
              verticalAlign: 'bottom'
            }
          },
          {
            type: 'value',
            min: that.lineMin,
            max: that.lineMax,
            axisLine: {
              lineStyle: {
                color: '#ccc'
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              color: '#000',
              formatter: (val) => {
                if (val.length > 10) {
                  return val.substring(0, 10) + '...';
                } else {
                  return val;
                }
              }
            }
          }
        ],
        series: []
      };
      const barSeriesOpt = this.$HMUtil.deepMerge({
        name: '',
        data: [],
        type: 'bar',
        barGap: 0,
        barWidth: that.data.length > 1 ? '32' : '32',
        label: {
          show: false,
          position: that.horizontal ? 'right' : 'top',
          color: '#000',
          formatter: '{c}'
        }
      }, this.seriesOpt);
      const lineSeriesOpt = {
        name: '',
        data: [],
        type: 'line',
        yAxisIndex: 0,
        smooth: false
      };
      const sourceData = this.data;
      const lineDataName = '/' + that.lineDataName.join('/') + '/';
      sourceData.map(item => {
        // 图表配置：legend图例数据赋值
        defaultOpt.legend.data.push(item.name);
        // 暂存x轴、点数据
        const xAxis = [];
        const seriesData = [];
        item.data.map(dataItem => {
          xAxis.push(dataItem.name);
          seriesData.push(dataItem.value);
        });
        defaultOpt.xAxis.data = xAxis;
        if (lineDataName.indexOf('/' + item.name + '/') > -1) {
          defaultOpt.series.push({
            ...lineSeriesOpt,
            ...{
              name: item.name,
              data: seriesData
            }
          });
        } else {
          defaultOpt.series.push({
            ...barSeriesOpt,
            ...{
              name: item.name,
              data: seriesData
            }
          });
        }
      });
      const defaultYAxis = defaultOpt.yAxis;
      const newDefault = this.$HMUtil.deepMerge(defaultOpt, this.chartOpt);
      if (this.chartOpt.yAxis && this.chartOpt.yAxis.length >= 1) {
        defaultYAxis[0] = this.$HMUtil.deepMerge(defaultYAxis[0], this.chartOpt.yAxis[0]);
      }
      if (this.chartOpt.yAxis && this.chartOpt.yAxis.length === 2) {
        defaultYAxis[1] = this.$HMUtil.deepMerge(defaultYAxis[1], this.chartOpt.yAxis[1]);
      }
      return this.$HMUtil.deepMerge(newDefault, { yAxis: defaultYAxis });
    },
    chartData () {
      const chartData = {
        legend: [],
        xAxis: [],
        series: []
      };
      const sourceData = this.data;
      if (!this.multiply) {
        sourceData.map(item => {
          chartData.xAxis.push(item.name);
          chartData.series.push(item.value);
        });
      } else {
        sourceData.map(item => {
          chartData.legend.push(item.name);
          const xAxis = [];
          const seriesData = [];
          item.data.map(dataItem => {
            xAxis.push(dataItem.name);
            seriesData.push(dataItem.value);
          });
          chartData.xAxis = xAxis;
          chartData.series.push(seriesData);
        });
      }
      return chartData;
    },
    opt () {
      const that = this;
      const obj = {
        title: {
          text: that.title,
          x: 'center'
        },
        legend: that.originChartOpt.legend,
        color: chartConfig.color,
        toolbox: that.originChartOpt.toolbox,
        tooltip: that.originChartOpt.tooltip,
        grid: that.originChartOpt.grid,
        xAxis: that.horizontal ? that.originChartOpt.yAxis : that.originChartOpt.xAxis,
        yAxis: that.horizontal ? that.originChartOpt.xAxis : that.originChartOpt.yAxis,
        series: that.originChartOpt.series
      };
      return obj;
    }
  },
  methods: {
    setEchart () {
      const dom = this.$refs.vueChart;
      this.vueChart = this.$echarts.init(dom, {
        width: 'auto',
        height: 'auto'
      });
      this.vueChart.setOption(this.opt);
      console.log('option', this.opt);
      const that = this;
      this.vueChart.on('finished', function () {
        that.$emit('update:isFinished', true);
      });
    },
    resizeChart () {
      if (this.vueChart) {
        this.vueChart.resize();
      }
    },
    chartChange () {
      this.$emit('update:isFinished', false);
      this.vueChart.clear();
      this.vueChart.setOption(this.opt);
    },
    chartDownload () {
      const _href = this.vueChart.getDataURL({
        pixelRatio: 2,
        backgroundColor: '#fff'
      });
      this.$HMUtil.openForDownload(_href, this.title);
    },
    getBase64Img () {
      const base64Img = this.vueChart.getDataURL({
        pixelRatio: 2,
        backgroundColor: '#fff'
      });
      return base64Img.replace('data:image/png;base64,', '');
    }
  },
  mounted () {
    this.setEchart();
  },
  updated () {
    if (Object.keys(this.vueChart).length === 0) {
      this.setEchart();
    }
    this.chartChange();
  },
  beforeDestroy () {
    this.$emit('update:isFinished', false);
    this.$refs.chartWrapper.removeEventListener('resize', this.vueChart.resize);
  }
};
</script>
